export const APP_KEY = 'app';
export const APPS_KEY = 'apps';
export const APP_NETWORK_SETTINGS = 'appNetworkSettings';
export const APP_SPACE_SETTINGS = 'appSpaceSettings';
export const CREATE_APP_KEY = 'createApp';
export const UPDATE_APP_KEY = 'updateApp';
export const APP_INSTALLATIONS_KEY = 'appInstallations';
export const APP_COLLABORATORS_KEY = 'appCollaborators';
export const APP_PUBLICATIONS_KEY = 'appPublications';
export const getAppKey = (args) => args ? [APP_KEY, args] : [APP_KEY];
export const getAppsKey = (args) => args ? [APPS_KEY, args] : [APPS_KEY];
export const getAppNetworkSettingsKey = (args) => (args ? [APP_NETWORK_SETTINGS, args] : [APP_NETWORK_SETTINGS]);
export const getAppSpaceSettingsKey = (args) => args ? [APP_SPACE_SETTINGS, args] : [APP_SPACE_SETTINGS];
export const getCreateAppKey = () => CREATE_APP_KEY;
export const getUpdateAppKey = () => UPDATE_APP_KEY;
export const getAppInstallationsKey = (args) => (args ? [APP_INSTALLATIONS_KEY, args] : [APP_INSTALLATIONS_KEY]);
export const getAppCollaboratorsKey = (args) => (args ? [APP_COLLABORATORS_KEY, args] : [APP_COLLABORATORS_KEY]);
export const getAppPublicationsKey = (args) => args ? [APP_PUBLICATIONS_KEY, args] : [APP_PUBLICATIONS_KEY];
//# sourceMappingURL=app.key.js.map